<div class="onboarding-page">
  <!-- Left Sidebar - Progress -->
  <div class="onboarding-sidebar">
    <div class="onboarding-sidebar__header">
      <img src="assets/icon/meine-kommune-logo.svg" alt="Meine Kommune" class="onboarding-sidebar__logo" />
      <span class="onboarding-sidebar__brand">Meine Kommune</span>
    </div>

    <div class="onboarding-sidebar__progress">
      <div class="progress-ring">
        <svg viewBox="0 0 100 100">
          <circle class="progress-ring__bg" cx="50" cy="50" r="42"/>
          <circle class="progress-ring__fill" cx="50" cy="50" r="42"
            [style.stroke-dashoffset]="264 - (264 * currentStep / 3)"/>
        </svg>
        <span class="progress-ring__text">{{currentStep}}/3</span>
      </div>
    </div>

    <nav class="onboarding-nav">
      <div class="onboarding-nav__item"
        [class.onboarding-nav__item--active]="currentStep === 1"
        [class.onboarding-nav__item--done]="currentStep > 1">
        <div class="onboarding-nav__icon">
          <i *ngIf="currentStep > 1" class="pi pi-check"></i>
          <i *ngIf="currentStep <= 1" class="pi pi-envelope"></i>
        </div>
        <div class="onboarding-nav__content">
          <span class="onboarding-nav__step">Schritt 1</span>
          <span class="onboarding-nav__title">E-Mail bestätigen</span>
        </div>
      </div>

      <div class="onboarding-nav__item"
        [class.onboarding-nav__item--active]="currentStep === 2"
        [class.onboarding-nav__item--done]="currentStep > 2"
        [class.onboarding-nav__item--locked]="currentStep < 2">
        <div class="onboarding-nav__icon">
          <i *ngIf="currentStep > 2" class="pi pi-check"></i>
          <i *ngIf="currentStep <= 2" class="pi pi-user"></i>
        </div>
        <div class="onboarding-nav__content">
          <span class="onboarding-nav__step">Schritt 2</span>
          <span class="onboarding-nav__title">Persönliche Daten</span>
        </div>
      </div>

      <div class="onboarding-nav__item"
        [class.onboarding-nav__item--active]="currentStep === 3"
        [class.onboarding-nav__item--locked]="currentStep < 3">
        <div class="onboarding-nav__icon">
          <i class="pi pi-building"></i>
        </div>
        <div class="onboarding-nav__content">
          <span class="onboarding-nav__step">Schritt 3</span>
          <span class="onboarding-nav__title">Kommune wählen</span>
        </div>
      </div>
    </nav>

    <div class="onboarding-sidebar__footer">
      <p>Fragen? <a href="mailto:support@meine-kommune.de">Kontaktiere uns</a></p>
    </div>
  </div>

  <!-- Right Side - Content -->
  <div class="onboarding-content">
    <div class="onboarding-content__mobile-header">
      <img src="assets/icon/meine-kommune-logo.svg" alt="Meine Kommune" />
      <div class="onboarding-content__mobile-progress">
        <span>Schritt {{currentStep}} von 3</span>
        <div class="mobile-progress-bar">
          <div class="mobile-progress-bar__fill" [style.width.%]="(currentStep / 3) * 100"></div>
        </div>
      </div>
    </div>

    <div class="onboarding-content__inner">
      <!-- Step 1 -->
      <div *ngIf="currentStep === 1" class="onboarding-step">
        <div class="onboarding-step__icon"><i class="pi pi-envelope"></i></div>
        <h2 class="onboarding-step__title">E-Mail bestätigen</h2>
        <p class="onboarding-step__subtitle">Wir haben dir eine Bestätigungs-E-Mail gesendet. Klicke auf den Link, um fortzufahren.</p>

        <div class="onboarding-info-box">
          <i class="pi pi-info-circle"></i>
          <div>
            <strong>E-Mail nicht erhalten?</strong>
            <p>Prüfe den Spam-Ordner oder fordere eine neue E-Mail an.</p>
          </div>
        </div>

        <div class="onboarding-actions">
          <button type="button" class="auth-btn" (click)="sendVerificationEmail()" [disabled]="emailSent">
            <i *ngIf="emailSent" class="pi pi-spinner pi-spin"></i>
            <span *ngIf="!emailSent">E-Mail erneut senden</span>
          </button>
          <button type="button" class="auth-btn auth-btn--outline" (click)="checkOnboardingState()" [disabled]="loading">
            <i *ngIf="loading" class="pi pi-spinner pi-spin"></i>
            <span *ngIf="!loading">Status prüfen</span>
          </button>
        </div>
      </div>

      <!-- Step 2 -->
      <div *ngIf="currentStep === 2" class="onboarding-step">
        <h2 class="onboarding-step__title">Persönliche Daten</h2>
        <p class="onboarding-step__subtitle">Vervollständige deine Kontaktinformationen</p>

        <app-personal-details [detailsForm]="personalDetailsForm"></app-personal-details>

        <div class="onboarding-actions onboarding-actions--spaced">
          <button type="button" class="auth-btn auth-btn--outline" (click)="previousStep()">Zurück</button>
          <button type="button" class="auth-btn" (click)="savePersonalDetails()" [disabled]="loading || !personalDetailsForm.valid">
            <span *ngIf="!loading">Weiter</span>
            <i *ngIf="loading" class="pi pi-spinner pi-spin"></i>
          </button>
        </div>
      </div>

      <!-- Step 3 -->
      <div *ngIf="currentStep === 3" class="onboarding-step">
        <h2 class="onboarding-step__title">Kommune wählen</h2>
        <p class="onboarding-step__subtitle">Tritt einer bestehenden Kommune bei oder erstelle eine neue</p>

        <app-hub-selection
          [joinForm]="joinHubForm"
          [hubForm]="createHubForm"
          (selectionChange)="onHubSelectionChange($event)">
        </app-hub-selection>

        <div class="onboarding-actions onboarding-actions--spaced">
          <button type="button" class="auth-btn auth-btn--outline" (click)="previousStep()">Zurück</button>
          <button type="button" class="auth-btn" (click)="completeOnboarding()" [disabled]="loading || !canCompleteOnboarding()">
            <span *ngIf="!loading">Abschließen</span>
            <i *ngIf="loading" class="pi pi-spinner pi-spin"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
